module.exports = __webpack_public_path__ + "static/media/webhooks.1f462319.svg";